import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CarouselWithTitle } from "@faire/retailer-visitor-shared/components/Carousel/CarouselWithTitle";
import { ContentContainer } from "@faire/retailer-visitor-shared/components/GiftGuide/common";
import { ILeanBrandTile } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { LeanBrandTileRendererForCarousel } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/LeanBrandTileRendererForCarousel";
import { BASED_IN_EUROPE_URL_ID, ECO_CONSCIOUS_URL_ID } from "@faire/retailer-visitor-shared/services/Categories";
import { ProductCacheStore } from "@faire/retailer-visitor-shared/stores/domain/ProductCacheStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { QueryParameters as BrandSearchParameters } from "@faire/web-api--source/api/v2/search/brands/get";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { path as c1CategoryPath } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
var GiftCarousel = function(param) {
    var name = param.name, title = param.title, ctaText = param.ctaText, ctaLink = param.ctaLink, categoryUrlId = param.categoryUrlId;
    var viewport = useViewport();
    var _useState = _sliced_to_array(useState(), 2), brandSearchResponse = _useState[0], setBrandSearchResponse = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    useEffect(function() {
        var abortController = new AbortController();
        _async_to_generator(function() {
            var response, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            ProductCacheStore.get().brandSearch(BrandSearchParameters.build({
                                navigation_path: categoryUrlId,
                                page: 1,
                                page_size: 20,
                                suppress_filter_sections: true
                            }), {
                                signal: abortController.signal
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        setBrandSearchResponse(response);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            abortController.abort();
        };
    });
    var brandList = useMemo(function() {
        var _brandSearchResponse_brands_map;
        return (_brandSearchResponse_brands_map = brandSearchResponse === null || brandSearchResponse === void 0 ? void 0 : brandSearchResponse.brands.map(function(brand) {
            return IBrand.build(_object_spread_props(_object_spread({}, brand), {
                squared_image: brand.image,
                brand_promo_string: brand.highest_tier_promo_description,
                based_in: brand.based_in_country
            }));
        })) !== null && _brandSearchResponse_brands_map !== void 0 ? _brandSearchResponse_brands_map : [];
    }, [
        brandSearchResponse
    ]);
    var renderBrandTile = function(brand, index) {
        return /*#__PURE__*/ _jsx(LeanBrandTileRendererForCarousel, {
            leanBrandTile: ILeanBrandTile.fromIBrand(brand),
            signUpSourceId: "gift_page_carousel"
        }, brand.token || index);
    };
    var cta = /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: ctaLink,
        children: ctaText
    });
    var itemsPerSlide = useResponsiveValue({
        mobileAndAbove: 2,
        tabletAndAbove: 3,
        desktopAndAbove: 5
    });
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Row, {
            justify: "center",
            children: /*#__PURE__*/ _jsx(LoadingSpinner, {})
        });
    }
    return /*#__PURE__*/ _jsx(CarouselWithTitle, {
        leftAlignTitle: viewport.isTabletAndBelow,
        name: name,
        title: title,
        titleRight: cta,
        itemsPerSlide: itemsPerSlide,
        items: brandList,
        renderItem: renderBrandTile,
        itemGap: viewport.isMobile ? 8 : 24,
        padItems: true,
        peekNext: viewport.isMobile,
        peekGapPercent: 20
    });
};
export var GiftCarousels = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var viewport = useViewport();
    return /*#__PURE__*/ _jsxs(StyledContentContainer, {
        children: [
            /*#__PURE__*/ _jsx(GiftCarousel, {
                name: "seo-gift-page-eco-friendly-carousel",
                title: strictLocalize({
                    id: "4GsZUr",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Eco-friendly wholesale gifts"
                        }
                    ]
                }),
                ctaText: viewport.isMobile ? strictLocalize({
                    id: "Edj1ZC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "See All"
                        }
                    ]
                }) : strictLocalize({
                    id: "RJhGya",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Shop All Eco-Conscious Gifts"
                        }
                    ]
                }),
                ctaLink: c1CategoryPath(ECO_CONSCIOUS_URL_ID),
                categoryUrlId: ECO_CONSCIOUS_URL_ID
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: viewport.isMobile ? "4x" : "9x"
            }),
            /*#__PURE__*/ _jsx(GiftCarousel, {
                name: "seo-gift-page-european-boutique-carousel",
                title: strictLocalize({
                    id: "Fw68ru",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Top European boutique vendors"
                        }
                    ]
                }),
                ctaText: viewport.isMobile ? strictLocalize({
                    id: "Edj1ZC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "See All"
                        }
                    ]
                }) : strictLocalize({
                    id: "wGpDMz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Shop All European Brands"
                        }
                    ]
                }),
                ctaLink: c1CategoryPath(BASED_IN_EUROPE_URL_ID),
                categoryUrlId: BASED_IN_EUROPE_URL_ID
            })
        ]
    });
};
var StyledContentContainer = styled(ContentContainer).withConfig({
    componentId: "sc-2e3690ea-0"
})([
    "",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], responsiveMediaQueries.tabletAndAbove, getSpacing(0, "6x"), responsiveMediaQueries.xLargeAndAbove, getSpacing(0, 128));
